import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import translate from "@insite/client-framework/Translate";
import { InvoiceCollectionModel, InvoiceLineModel, InvoiceModel } from "@insite/client-framework/Types/ApiModels";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Button from "@insite/mobius/Button";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import {
    DataTableBody,
    DataTableRow,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    LoadingSpinner,
} from "@insite/mobius/index";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import * as React from "react";
import { css } from "styled-components";

import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

interface OwnProps {
    invoiceDetailsData: InvoiceCollectionModel;
    isLoading?: boolean;
}

export interface ADIInvoiceDetailsStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    wrapper?: InjectableCss;
    titleRow?: InjectableCss;
    buttonRow?: InjectableCss;
    title?: TypographyProps;
    tableStyles?: DataTableProps;
    rowContainer?: DataTableRowProps;
    fullWidthColumn?: DataTableCellBaseProps;
    halfWidthColumn?: DataTableCellBaseProps;
    addressColumn?: DataTableCellBaseProps;
    invoiceDetailsColumn?: DataTableCellBaseProps;
    invoiceTotalColumn?: DataTableCellBaseProps;
    redText?: TypographyProps;
    redTextLarge?: TypographyProps;
    redTextSmall?: TypographyProps;
    textSmall?: TypographyProps;
    addressText?: InjectableCss;
    customerNumberText?: InjectableCss;
    customerNumberBox?: InjectableCss;
    rightAlignText?: InjectableCss;
    centerAlignText?: InjectableCss;
    leftAlignText?: InjectableCss;
    InvoiceDateTableStyles?: DataTableProps;
    dottedBorderBottom?: DataTableProps;
    invoiceLinesHeader?: DataTableProps;
    invoiceLinesHeaderInner?: DataTableProps;
    invoiceLines?: DataTableProps;
    invoiceTotalContainer?: DataTableProps;
    invoiceTotalEmptyColumn?: DataTableCellBaseProps;
    invoiceTotalTableColumn?: DataTableCellBaseProps;
    columncontainer?: InjectableCss;
    columnheader?: InjectableCss;
    columnheader1?: InjectableCss;
    columndata?: InjectableCss;
    columndata1?: InjectableCss;
    qtysection?: InjectableCss;
    columnheader2?: InjectableCss;
    columnheader3?: InjectableCss;
    columndata2?: InjectableCss;
    columndata3?: InjectableCss;
    invoiceAdiLogo?: InjectableCss;
}

export const adiInvoiceDetailsStyles: ADIInvoiceDetailsStyles = {
    qtysection: {
        css: css`
            width: 33.33%;
            height: auto;
            @media print {
            }
        `,
    },
    columndata1: {
        css: css`
            //  width:40%;
            //  //width:auto;

            // overflow: hidden;
            @media print {
                // width: 30%;
                //width:auto;

                overflow: hidden;
                width: 46%;
                max-width: 44%;
                min-width: 44%;
            }

            //min-width:50%;
        `,
    },
    columndata2: {
        css: css`
            @media print {
                width: 14%;
                max-width: 14%;
                min-width: 14%;
                overflow: hidden;
            }
        `,
    },
    columndata3: {
        css: css`
            @media print {
                width: 12%;
                max-width: 12%;
                min-width: 12%;
                overflow: hidden;
            }
        `,
    },

    columndata: {
        css: css`
            width: 20%;
        `,
    },
    columnheader1: {
        css: css`
            display: table-cell;
            line-height: 1.125rem;
            padding: 1em 0.75em;
            vertical-align: top;
           

            overflow: hidden;
            @media print {
                width:46%
             
              max-width:46%;
                 min-width:46%;
            

                overflow: hidden;
            }
        `,
    },
    columnheader2: {
        css: css`
            display: table-cell;
            line-height: 1.125rem;
            padding: 1em 0.75em;
            vertical-align: top;

            overflow: hidden;

            @media print {
                width: 14%;
                min-width: 14%;
                min-width: 14%;

                overflow: hidden;
            }
        `,
    },
    columnheader3: {
        css: css`
            display: table-cell;
            line-height: 1.125rem;
            padding: 1em 0.75em;
            vertical-align: top;

            overflow: hidden;

            @media print {
                width: 12%;
                min-width: 12%;
                min-width: 12%;

                overflow: hidden;
            }
        `,
    },
    columnheader: {
        css: css`
            display: table-cell;
            line-height: 1.125rem;
            padding: 1em 0.75em;
            vertical-align: top;
            width: 20%;
        `,
    },
    columncontainer: {
        css: css`
            height: auto;
            @media print {
                padding: 0px !important;

                width: auto !important;
                min-width: 100% !important;

                border-bottom: #e0e0e0 1px solid !important;
            }
        `,
    },
    centeringWrapper: {
        css: css`
            height: 150px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    wrapper: {
        css: css`
            width: 100%;
            font-family: verdana;
            font-size: 14px;
            overflow: auto;

            div {
                color: ${ADIColors.gray17};
            }
            @media print {
                font-size: 11px;
                 .tableheader{
                table{
                width:93% !important;
                
                margin:50px auto 0px auto;
                }
                }
            }
            .tableheader {
                @media print {
                    width: auto !important;
                    min-width: 100% !important;
                }

                .tablecolumrow {
                    @media print {
                        width: auto !important;
                        min-width: 100% !important;
                    }
                }
                .tableheaderrow {
                    @media print {
                        width: auto !important;
                        min-width: 100% !important;
                    }
                }
            }
        `,
    },
    titleRow: {
        css: css`
            width: 100%;
            padding: 0;
            @media print {
                display: none;
            }
        `,
    },
    buttonRow: {
        css: css`
            width: 100%;
            padding: 20px 0;
            justify-content: flex-end;
            display: flex;
            @media print {
                padding: 10px 0;
            }
        `,
    },
    title: {
        weight: "normal",
        size: "20px",
        as: "h1",
        color: `${ADIColors.black}`,
        css: css`
            width: 100%;
            padding: 0;
            margin: 0;
        `,
    },
    tableStyles: {
        css: css`
            &.wrapperTable {
                tr {
                    background: ${ADIColors.white};
                    border: none;
                    &:nth-child(even) {
                        background: ${ADIColors.white};
                    }
                    td {
                        border: none;
                    }
                }
            }
        `,
    },
    fullWidthColumn: {
        css: css`
            width: 100%;
        `,
    },
    halfWidthColumn: {
        css: css`
            width: 50%;
        `,
    },
    addressColumn: {
        css: css`
            width: 25%;
            div {
                white-space: initial;
            }
        `,
    },
    invoiceDetailsColumn: {
        css: css`
            width: 25%;
            @media print {
                width: 35%;
            }
        `,
    },
    invoiceTotalColumn: {
        css: css`
            width: 50%;
        `,
    },
    redText: {
        css: css`
            color: red;
            font-size: 18px;
            @media print {
                font-size: 16px;
            }
        `,
    },
    redTextLarge: {
        css: css`
            color: red;
            font-size: 32px;
            @media print {
                font-size: 24px;
            }
        `,
    },
    redTextSmall: {
        css: css`
            color: red;
            font-size: 12px;
        `,
    },
    textSmall: {
        css: css`
            font-size: 12px;
            white-space: initial;
            margin-top: 10px;
        `,
    },
    addressText: {
        css: css`
            margin-top: 40px;
            @media print {
                margin-top: 10px;
            }
        `,
    },
    customerNumberText: {
        css: css`
            margin-top: 20px;
            @media print {
                margin-top: 10px;
            }
        `,
    },
    customerNumberBox: {
        css: css`
            border: ${ADIColors.black} 1px solid;
            padding: 10px;
            text-align: center;
            margin: 10px 0px 10px -12px;
        `,
    },
    centerAlignText: {
        css: css`
            text-align: center !important;
        `,
    },
    leftAlignText: {
        css: css`
            text-align: left !important;
        `,
    },
    rightAlignText: {
        css: css`
            text-align: right;
        `,
    },
    InvoiceDateTableStyles: {
        css: css`
            border: ${ADIColors.black} 1px solid;
            border-right: none;
            margin-left: 20px;
            max-width: 330px;
            margin-right: 30px;
            @media print {
                margin-left: 5px;
                margin-right: 5px;
                max-width: 250px;
            }
            &.invoiceDateTable {
                tr {
                    background: ${ADIColors.white};
                    &:nth-child(even) {
                        background: ${ADIColors.white};
                    }
                    td {
                        border-bottom: ${ADIColors.black} 1px solid;
                        border-right: ${ADIColors.black} 1px solid;
                        text-align: center;
                        height: 40px;
                        @media print {
                            height: 30px;
                        }
                    }
                }
            }
        `,
    },
    dottedBorderBottom: {
        css: css`
            border-bottom: 1px dashed ${ADIColors.black};
            text-align: center;
            td {
                padding-bottom: 10px;
            }
        `,
    },
    invoiceLinesHeader: {
        css: css`
            margin-top: 30px;
        `,
    },
    invoiceLinesHeaderInner: {
        css: css`
            width: calc(100% - 50px);
            margin-left: 50px;
            @media print {
                margin-left: 10px;
            }
            th {
                background: ${ADIColors.blue4};
                color: ${ADIColors.white};
                font-weight: 700;
                border-right: ${ADIColors.white} 1px solid;
                text-align: center;
                @media print {
                    border: ${ADIColors.gray18} 1px solid;
                    color: ${ADIColors.black};
                    padding: 0;
                    height: auto;
                }
            }
            td {
                border: ${ADIColors.gray18} 1px solid !important;
                text-align: right;
                @media print {
                    color: ${ADIColors.black};
                    padding: 0;
                    height: auto;
                }
            }
        `,
    },
    invoiceLines: {
        css: css`
            margin-top: 50px;
            table-position: fixed;

            th {
                background: ${ADIColors.blue4};
                color: ${ADIColors.white};
                font-weight: 700;
                border-right: ${ADIColors.white} 1px solid;
                text-align: center;
                @media print {
                    border: ${ADIColors.gray18} 1px solid;
                    color: ${ADIColors.black};
                    font-size: 14px;
                    padding: 0;
                    height: auto;
                    span {
                        color: ${ADIColors.black};
                        font-size: 12px;
                    }
                }
            }
            td {
                border: ${ADIColors.gray18} 1px solid !important;
                text-align: right;
                @media print {
                    padding: 0;
                    height: auto;
                }
            }
        `,
    },
    invoiceTotalContainer: {
        css: css`
            border-collapse: initial;
            border: ${ADIColors.gray18} 1px solid;
            padding: 10px;
            margin-top: 30px;
            margin-bottom: 10px;
            td {
                height: auto;
                text-align: right;
                span {
                    font-size: 14px;
                }
            }
                @media print {
                width: 97%;
            }
        `,
    },
    invoiceTotalEmptyColumn: {
        css: css`
            width: 50%;
            @media print {
                width: 0;
            }
        `,
    },
    invoiceTotalTableColumn: {
        css: css`
            width: 50%;
            @media print {
                width: 100%;
            }
        `,
    },
    invoiceAdiLogo: {
        css: css`
            img {
                max-width: 110px;
                max-height: 100%;
            }
        `,
    },
};

const styles = adiInvoiceDetailsStyles;

const ADIInvoiceDetailsPrintView: React.FC<OwnProps> = ({ invoiceDetailsData, isLoading }) => {
    if (!invoiceDetailsData.invoices) {
        return null;
    }
    const invoiceDetails = invoiceDetailsData.invoices[0];
    const invoiceLines = invoiceDetailsData.invoices[0].invoiceLines;  
    if (isLoading) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner}></LoadingSpinner>
            </StyledWrapper>
        );
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.titleRow}>
                <Typography variant="h1" {...styles.title}>
                    {translate("Invoice Details")}
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.buttonRow}>
                <Button onClick={openPrintDialog} data-test-selector="invoiceDetails_print">
                    {translate("Print")}
                </Button>
            </StyledWrapper>
            <DataTable {...styles.tableStyles} className="wrapperTable">
                <DataTableBody>
                    <DataTableRow {...styles.rowContainer}>
                        <DataTableCell valign="top" {...styles.addressColumn}>
                            <StyledWrapper {...styles.invoiceAdiLogo}>
                                <img src="/userfiles/Images/ADI_Logo_Blue.png" />
                            </StyledWrapper>
                            {invoiceDetails.properties?.cusAddr1 && (
                                <StyledWrapper {...styles.addressText}>
                                    {invoiceDetails.properties.cusAddr1}
                                </StyledWrapper>
                            )}
                            {invoiceDetails.properties?.cusAddr2 && (
                                <StyledWrapper>{invoiceDetails.properties.cusAddr2}</StyledWrapper>
                            )}
                            {/* {invoiceDetails.properties?.remiT_LN3 && (
                                <StyledWrapper>{invoiceDetails.properties.remiT_LN3}</StyledWrapper>
                            )} */}
                            {/* properties names ----P21 Chnage */}
                            {invoiceDetails.properties?.salE_PHONe && (
                                <StyledWrapper>{invoiceDetails.properties.salE_PHONe}</StyledWrapper>
                            )}
                            {invoiceDetails?.stAddress1 && (
                                <StyledWrapper {...styles.addressText}>
                                    {invoiceDetails.stAddress1}
                                </StyledWrapper>
                            )}
                            {invoiceDetails?.shipToCity && (
                                <StyledWrapper>{invoiceDetails.shipToCity}</StyledWrapper>
                            )}
                            {invoiceDetails?.shipToState && (
                                <StyledWrapper>{invoiceDetails.shipToState}</StyledWrapper>
                            )}
                            {invoiceDetails?.shipToPostalCode && (
                                <StyledWrapper>{invoiceDetails.shipToPostalCode}</StyledWrapper>
                            )}
                        </DataTableCell>
                        <DataTableCell valign="top" {...styles.invoiceDetailsColumn}>
                            <Typography as="p" {...styles.redText}>
                                {translate("DUPLICATE INVOICE")}
                            </Typography>
                            <StyledWrapper {...styles.customerNumberText}>
                                <Typography as="p">{translate("CUSTOMER NUMBER")}</Typography>
                                <Typography as="p">{translate("PLEASE WRITE THIS NUMBER")}</Typography>
                                <Typography as="p">{translate("ON ALL ORDERS AND CHECKS")}</Typography>
                            </StyledWrapper>
                            <StyledWrapper {...styles.customerNumberBox}>{invoiceDetails.customerNumber}</StyledWrapper>
                            <StyledWrapper {...styles.rightAlignText}>
                                <Typography as="p" weight={700}>
                                    {translate("PLEASE PAY THIS AMOUNT")}
                                </Typography>
                            </StyledWrapper>
                            <StyledWrapper {...styles.rightAlignText}>
                                <Typography as="p" weight={700}>
                                    {translate("DUE DATE")}
                                </Typography>
                            </StyledWrapper>
                        </DataTableCell>
                        <DataTableCell valign="top" {...styles.invoiceTotalColumn}>
                            <DataTable {...styles.InvoiceDateTableStyles} className="invoiceDateTable">
                                <DataTableRow>
                                    <DataTableCell>
                                        <Typography as="p" weight={700}>
                                            {translate("PAGE")}
                                        </Typography>
                                    </DataTableCell>
                                    <DataTableCell>
                                        <Typography as="p" weight={700}>
                                            {translate("INVOICE DATE")}
                                        </Typography>
                                    </DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell>
                                        <Typography as="p">1</Typography>
                                    </DataTableCell>
                                    <DataTableCell>
                                        <Typography as="p">
                                            <LocalizedDateTime dateTime={invoiceDetails.invoiceDate} />
                                        </Typography>
                                    </DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell colSpan={2}>
                                        <Typography as="p" weight={700}>
                                            {translate("INVOICE NUMBER")}
                                        </Typography>
                                    </DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell colSpan={2}>
                                        <Typography as="p">{invoiceDetails.invoiceNumber}</Typography>
                                    </DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell colSpan={2}>
                                        <Typography as="p">{invoiceDetails.invoiceTotal}</Typography>
                                    </DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell colSpan={2}>
                                        <Typography as="p">{invoiceDetails.properties?.inV_DueDate}</Typography>
                                    </DataTableCell>
                                </DataTableRow>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                    <DataTableRow {...styles.rowContainer}>
                        <DataTableCell {...styles.addressText}></DataTableCell>
                        <DataTableCell {...styles.invoiceDetailsColumn}>
                            <Typography as="p" weight={700} {...styles.addressText}>
                                {translate("PLEASE REMIT TO")}
                            </Typography>
                            {invoiceDetails.properties?.remiT_LN1 && (
                                <StyledWrapper>{invoiceDetails.properties.remiT_LN1}</StyledWrapper>
                            )}
                            {invoiceDetails.properties?.remiT_LN2 && (
                                <StyledWrapper>{invoiceDetails.properties.remiT_LN2}</StyledWrapper>
                            )}
                            {invoiceDetails.properties?.remiT_LN3 && (
                                <StyledWrapper>{invoiceDetails.properties.remiT_LN3}</StyledWrapper>
                            )}
                            {invoiceDetails.properties?.remiT_PHONE && (
                                <StyledWrapper>{invoiceDetails.properties.remiT_PHONE}</StyledWrapper>
                            )}
                        </DataTableCell>
                        <DataTableCell {...styles.invoiceTotalColumn}></DataTableCell>
                    </DataTableRow>
                    <DataTableRow {...styles.rowContainer}>
                        <DataTableCell colSpan={3}>
                            <DataTable {...styles.dottedBorderBottom}>
                                <DataTableRow>
                                    <DataTableCell {...styles.halfWidthColumn}>
                                        <StyledWrapper {...styles.centerAlignText}>
                                            <Typography as="p" weight={700} {...styles.addressText}>
                                                {translate("Please detach and enclose top portion with your payment")}
                                            </Typography>
                                        </StyledWrapper>
                                    </DataTableCell>
                                    <DataTableCell {...styles.halfWidthColumn}>
                                        <StyledWrapper {...styles.centerAlignText}>
                                            <Typography as="p" weight={700} {...styles.addressText}>
                                                {translate("Make check payable and remit to above address")}
                                            </Typography>
                                        </StyledWrapper>
                                    </DataTableCell>
                                </DataTableRow>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                    <DataTableRow {...styles.rowContainer}>
                        <DataTableCell colSpan={3}>
                            <DataTable {...styles.invoiceLinesHeader}>
                                <DataTableRow>
                                    <DataTableCell>
                                        <StyledWrapper {...styles.invoiceAdiLogo}>
                                            <img src="/userfiles/Images/ADI_Logo_Blue.png" />
                                        </StyledWrapper>
                                    </DataTableCell>
                                    <DataTableCell>
                                        <DataTable {...styles.invoiceLinesHeaderInner}>
                                            <DataTableHead>
                                                <DataTableHeader {...styles.columnheader}>
                                                    <Typography>{translate("CUSTOMER NUMBER")}</Typography>
                                                </DataTableHeader>
                                                <DataTableHeader {...styles.columnheader}>
                                                    <Typography>{translate("INVOICE NUMBER")}</Typography>
                                                </DataTableHeader>
                                                <DataTableHeader {...styles.columnheader}>
                                                    <Typography>{translate("DATE")}</Typography>
                                                </DataTableHeader>
                                            </DataTableHead>
                                            <DataTableBody>
                                                <DataTableRow>
                                                    <DataTableCell>{invoiceDetails.customerNumber}</DataTableCell>
                                                    <DataTableCell>{invoiceDetails.invoiceNumber}</DataTableCell>
                                                    <DataTableCell>
                                                        <LocalizedDateTime dateTime={invoiceDetails.invoiceDate} />
                                                    </DataTableCell>
                                                </DataTableRow>
                                            </DataTableBody>
                                        </DataTable>
                                    </DataTableCell>
                                    <DataTableCell>
                                        <Typography as="p" weight={700} {...styles.addressText}>
                                            {translate("Retain this portion for your records")}
                                        </Typography>
                                    </DataTableCell>
                                </DataTableRow>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                    <DataTableRow {...styles.rowContainer} className="tableheader">
                        <DataTableCell colSpan={3} {...styles.columncontainer}>
                            <DataTable {...styles.invoiceLines}>
                                <DataTableHead className="tableheaderrow">
                                    <DataTableHeader {...styles.columnheader1}>
                                        {translate("SHIP DATA/ITEM DESCRIPTIONS")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.columnheader2}>
                                        {translate("CATALOG NUMBER")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.columnheader2}>
                                        {translate("QTY ORDERED")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.columnheader3}>
                                        {translate("UNIT PRICE")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.columnheader3}>{translate("AMOUNT")}</DataTableHeader>
                                </DataTableHead>
                                <DataTableBody className="tablecolumrow">
                                    {invoiceLines &&
                                        invoiceLines.map(invoiceLine => (
                                            <DataTableRow key={invoiceLine.id}>
                                                <DataTableCell {...styles.columndata1}>
                                                    <StyledWrapper>{`SHIP FROM: TO: ${invoiceDetails.shipToState} ${invoiceLine.properties?.caT_NO}`}</StyledWrapper>

                                                    <StyledWrapper>{`PO: ${invoiceDetails.properties?.cusT_PO} REF: ${invoiceDetails.properties?.cusT_REF}`}</StyledWrapper>
                                                    <StyledWrapper>{invoiceLine.description}</StyledWrapper>
                                                    <StyledWrapper>{`SHIP VIA: ${invoiceDetails.shipCode}`}</StyledWrapper>
                                                </DataTableCell>
                                                <DataTableCell {...styles.columndata2}>
                                                    {invoiceLine.customerProductNumber}
                                                </DataTableCell>
                                                <DataTableCell {...styles.columndata2}>
                                                    {invoiceLine.qtyInvoiced}
                                                </DataTableCell>
                                                <DataTableCell {...styles.columndata3}>
                                                    {invoiceLine.unitPrice}
                                                </DataTableCell>
                                                <DataTableCell {...styles.columndata3}>
                                                    {invoiceLine.lineTotal}
                                                </DataTableCell>
                                            </DataTableRow>
                                        ))}
                                </DataTableBody>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                    <DataTableRow {...styles.rowContainer}>
                        <DataTableCell {...styles.invoiceTotalEmptyColumn}>&nbsp;</DataTableCell>
                        <DataTableCell {...styles.invoiceTotalTableColumn} colSpan={2}>
                            <DataTable {...styles.invoiceTotalContainer}>
                                <DataTableRow>
                                    <DataTableCell>
                                        <StyledWrapper {...styles.leftAlignText}>
                                            {translate("TOTAL MATERIAL")}
                                        </StyledWrapper>
                                    </DataTableCell>
                                    <DataTableCell>{Number(invoiceDetails.productTotal).toFixed(2).toString()}</DataTableCell>
                                </DataTableRow>
                                {
                                    invoiceDetails?.invoiceHistoryTaxes?.map((invoiceHistory) => {
                                        return (
                                            <DataTableRow key={invoiceHistory.taxDescription}>
                                            <DataTableCell>
                                                <StyledWrapper {...styles.leftAlignText}>
                                                    {invoiceHistory?.taxDescription}
                                                </StyledWrapper>
                                            </DataTableCell>
                                            <DataTableCell>{invoiceHistory?.taxAmountDisplay}</DataTableCell>
                                        </DataTableRow>
                                        )
                                    })
                                }
                                {invoiceDetails.properties?.gstAmount && !window.location.href.includes(".us") &&(
                                    <DataTableRow>
                                        <DataTableCell>
                                            <StyledWrapper {...styles.leftAlignText}>
                                                {translate("GS TAX")}
                                            </StyledWrapper>
                                        </DataTableCell>
                                        <DataTableCell>{Number(invoiceDetails.productTotal).toFixed(2).toString()}</DataTableCell>
                                    </DataTableRow>
                                )}
                                {/* ecofee changes -- P21 Change */}
                                 {(invoiceDetails.properties?.ecoFee && invoiceDetails.properties?.ecoFee !== "0000.00") && (
                                    <DataTableRow>
                                        <DataTableCell><StyledWrapper {...styles.leftAlignText}>{translate("ECO FEE")}</StyledWrapper></DataTableCell>
                                        <DataTableCell>{invoiceDetails.properties?.ecoFee}</DataTableCell>
                                    </DataTableRow>
                                )}
                                {(invoiceDetails.properties?.specialHandlingFee && invoiceDetails.properties?.specialHandlingFee !== "0.00") && (
                                    <DataTableRow>
                                        <DataTableCell><StyledWrapper {...styles.leftAlignText}>{translate("SPECIAL HANDLING FEE")}</StyledWrapper></DataTableCell>
                                        <DataTableCell>{invoiceDetails.properties?.specialHandlingFee}</DataTableCell>
                                    </DataTableRow>
                                )}
                                <DataTableRow>
                                    <DataTableCell>
                                        <StyledWrapper {...styles.leftAlignText}>
                                            {translate("SHIPPING HANDLING")}
                                        </StyledWrapper>
                                    </DataTableCell>
                                    <DataTableCell>{Number(invoiceDetails.shippingAndHandling).toFixed(2).toString()}</DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell>
                                        <StyledWrapper {...styles.leftAlignText}>
                                            <strong>{translate("TOTAL INVOICE")}</strong>
                                        </StyledWrapper>
                                    </DataTableCell>
                                    <DataTableCell>
                                        <strong>{Number(invoiceDetails.invoiceTotal).toFixed(2).toString()}</strong>
                                    </DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell>
                                        <StyledWrapper {...styles.leftAlignText}>
                                            <strong>{translate("DUE DATE")}</strong>
                                        </StyledWrapper>
                                    </DataTableCell>
                                    <DataTableCell>
                                        {invoiceDetails.properties?.inV_DueDate && (
                                            <strong>{(invoiceDetails.dueDate).toString().split("T")[0]}</strong>
                                        )}
                                    </DataTableCell>
                                </DataTableRow>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                    <DataTableRow>
                        <DataTableCell colSpan={3}>
                            <DataTable {...styles.dottedBorderBottom}>
                                <DataTableRow>
                                    <DataTableCell {...styles.fullWidthColumn}>
                                        <StyledWrapper {...styles.centerAlignText}>
                                            <Typography {...styles.redTextLarge}>
                                                {translate("THANK YOU FOR YOUR ORDER.")}
                                            </Typography>
                                        </StyledWrapper>
                                    </DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell {...styles.fullWidthColumn}>
                                        <StyledWrapper {...styles.textSmall}>
                                            {translate(
                                                "All claims must be made within 5 days after receipt of goods. Goods returned without our authorized return number on the carton will be refused. The purchase of products and services from ADI are subject to and governed soley by the Terms and Conditions on the back of this invoice.",
                                            )}
                                        </StyledWrapper>
                                        <Typography as="p" {...styles.redTextSmall}>
                                            {translate(
                                                "Past due balances may be subject to a Late Charge not to exceed 1.5% per month.",
                                            )}
                                        </Typography>
                                    </DataTableCell>
                                </DataTableRow>
                                <DataTableRow>
                                    <DataTableCell {...styles.fullWidthColumn}>
                                        <StyledWrapper {...styles.centerAlignText}>
                                            <Typography {...styles.redTextLarge}>
                                                {translate("SHIP NOTIFICATIONS")}
                                            </Typography>
                                        </StyledWrapper>
                                    </DataTableCell>
                                </DataTableRow>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                    <DataTableRow>
                        <DataTableCell colSpan={3}>
                            <DataTable {...styles.invoiceLinesHeader}>
                                <DataTableRow>
                                    <DataTableCell>
                                        <StyledWrapper {...styles.invoiceAdiLogo}>
                                            <img src="/userfiles/Images/ADI_Logo_Blue.png" />
                                        </StyledWrapper>
                                    </DataTableCell>
                                    <DataTableCell>
                                        <DataTable {...styles.invoiceLinesHeaderInner}>
                                            <DataTableHead>
                                                <DataTableHeader>
                                                    <Typography>{translate("CUSTOMER NUMBER")}</Typography>
                                                </DataTableHeader>
                                                <DataTableHeader>
                                                    <Typography>{translate("NOTIFICATION")}</Typography>
                                                </DataTableHeader>
                                                <DataTableHeader>
                                                    <Typography>{translate("INVOICE DATE")}</Typography>
                                                </DataTableHeader>
                                            </DataTableHead>
                                            <DataTableBody>
                                                <DataTableRow>
                                                    <DataTableCell>
                                                        <StyledWrapper {...styles.centerAlignText}>
                                                            {invoiceDetails.customerNumber}
                                                        </StyledWrapper>
                                                    </DataTableCell>
                                                    <DataTableCell>
                                                        <StyledWrapper {...styles.centerAlignText}>
                                                            {translate("SHIPPED")}
                                                        </StyledWrapper>
                                                    </DataTableCell>
                                                    <DataTableCell>
                                                        <StyledWrapper {...styles.centerAlignText}>
                                                            <LocalizedDateTime dateTime={invoiceDetails.invoiceDate} />
                                                        </StyledWrapper>
                                                    </DataTableCell>
                                                </DataTableRow>
                                            </DataTableBody>
                                        </DataTable>
                                    </DataTableCell>
                                </DataTableRow>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                    <DataTableRow {...styles.rowContainer}>
                        <DataTableCell colSpan={3}>
                            <DataTable {...styles.invoiceLines}>
                                <DataTableHead>
                                    <DataTableHeader {...styles.qtysection}>{translate("QTY ORDERED")}</DataTableHeader>
                                    <DataTableHeader {...styles.qtysection}>
                                        {translate("CATALOG NUMBER")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.qtysection}>
                                        {translate("ITEM DESCRIPTIONS")}
                                    </DataTableHeader>
                                </DataTableHead>
                                <DataTableBody>
                                    {invoiceLines &&
                                        invoiceLines.map(lineItem => (
                                            <DataTableRow key={lineItem.id}>
                                                <DataTableCell {...styles.qtysection}>
                                                    <StyledWrapper {...styles.centerAlignText}>
                                                        {lineItem.qtyInvoiced}
                                                    </StyledWrapper>
                                                </DataTableCell>
                                                <DataTableCell {...styles.qtysection}>
                                                    <StyledWrapper {...styles.centerAlignText}>
                                                        {lineItem.customerProductNumber}
                                                    </StyledWrapper>
                                                </DataTableCell>
                                                <DataTableCell {...styles.qtysection}>
                                                    <StyledWrapper {...styles.centerAlignText}>
                                                        {lineItem.description}
                                                    </StyledWrapper>
                                                </DataTableCell>
                                            </DataTableRow>
                                        ))}
                                </DataTableBody>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                    <DataTableRow {...styles.rowContainer}>
                        <DataTableCell colSpan={3}>
                            <DataTable {...styles.invoiceLines}>
                                <DataTableHead>
                                    <DataTableHeader>{translate("RECEPIENT NAME")}</DataTableHeader>
                                </DataTableHead>
                                <DataTableBody>
                                    <DataTableRow>
                                        <DataTableCell>
                                            <StyledWrapper {...styles.leftAlignText}>
                                                {invoiceDetails.stAddress1}
                                            </StyledWrapper>
                                        </DataTableCell>
                                    </DataTableRow>
                                </DataTableBody>
                            </DataTable>
                        </DataTableCell>
                    </DataTableRow>
                </DataTableBody>
            </DataTable>
            <StyledWrapper {...styles.buttonRow}>
                <Button onClick={openPrintDialog} data-test-selector="invoiceDetails_print">
                    {translate("Print")}
                </Button>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default ADIInvoiceDetailsPrintView;
